import { render, staticRenderFns } from "./DWorkspacesDropMenu.vue?vue&type=template&id=b0b16824&scoped=true&"
import script from "./DWorkspacesDropMenu.vue?vue&type=script&lang=js&"
export * from "./DWorkspacesDropMenu.vue?vue&type=script&lang=js&"
import style0 from "./DWorkspacesDropMenu.vue?vue&type=style&index=0&id=b0b16824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b16824",
  null
  
)

export default component.exports